import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_OL_RISOLUZIONE } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIdOlRisoluzioneState extends EntityState<IID_OL_RISOLUZIONE, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_OL_RISOLUZIONE })
@InterfaceDataStore(InterfaceName.OLO_RISOLUZIONE)
export class IIDolRisoluzioneStore extends EntityStore<IIdOlRisoluzioneState> {
  constructor() {
    super([]);
  }
}
